import CaptchaErrorModal from './CaptchaErrorModal';
export default CaptchaErrorModal;
